import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Wordmark } from "@/components/Brand";
import { CONTACT_EMAIL } from "@/lib/brand";

export default function LegalPage({ title, children, testId }) {
  return (
    <div data-testid={testId} className="min-h-screen bg-white text-[#2B2B2B]">
      <header className="border-b border-[#E5E5E5]">
        <div className="mx-auto max-w-4xl px-5 sm:px-8 py-5 flex items-center justify-between">
          <Link to="/" data-testid="legal-logo-home"><Wordmark /></Link>
          <Link
            to="/"
            data-testid="legal-back-link"
            className="inline-flex items-center gap-2 text-sm font-medium text-[#2B2B2B]/60 hover:text-[#2B2B2B] transition-colors"
          >
            <ArrowLeft size={16} /> Back to site
          </Link>
        </div>
      </header>

      <main className="mx-auto max-w-3xl px-5 sm:px-8 py-16 lg:py-24">
        <p className="overline text-[#2BBFB3]">Legal</p>
        <h1 className="mt-4 font-display font-extrabold tracking-tight text-4xl sm:text-5xl">{title}</h1>
        <p className="mt-4 text-[#2B2B2B]/50">Placeholder document — final copy to be provided.</p>
        <div className="mt-10 space-y-6 text-[#2B2B2B]/70 leading-relaxed">{children}</div>
        <p className="mt-12 text-sm text-[#2B2B2B]/50">
          Questions? Contact us at{" "}
          <a href={`mailto:${CONTACT_EMAIL}`} className="text-[#1FA097] font-medium">{CONTACT_EMAIL}</a>.
        </p>
      </main>
    </div>
  );
}
